import io from "socket.io-client";

const SocketUrl = process.env.REACT_APP_SOCKET_URL

export const SocketEndPoint = io.connect(SocketUrl)